export enum DocumentMainStatus{
    New = 2,
    Draft = 3,
    Pending_Approval = 4,
    Completed = 5,
    Rejected = 6,
    Pending_Validation = 7,
    Pending_Recommendation = 8,
    Pending_Quotation = 9,
    Cancelled = 10,
    Pending_PR = 11,
    Pending_Offer = 12,
    Terminated = 14,
    Pending_PE_Sourcing = 15
}

export enum DocumentSubStatus{ 
    New = 1,
    Draft = 2,
    Aor_Rejected = 11,
    Aor_Draft = 12,
    Woc_Rejected  = 16,
    Woc_Draft = 17,
    Woc_Dotp_Draft = 19,
    Rfq_Sent = 25,
    D_Procurement_Draft = 29,
    Pending_Sow_Approval = 30,
    Sow_Rejected = 38,
    Pending_Tender_Document = 41,
    Pending_Tender_Document_Approval = 42,
    Pending_Tender_Release = 43,
    Tender_Released = 44,
    Tender_Terminated = 45,
    Sow_Draft = 47,
    Vendor_Document_Draft = 52,
    Vendor_Document_Rejected = 53,
    Pending_Woc_Dotp_Approval = 58,
    Woc_Dotp_Approved = 60,
    Woc_Dotp_Rejected = 61,
    Rfs_Draft = 62,
    Pending_Sourcing = 63,
    Pending_Quotation_Attachment = 66,
    Awaiting_Rfq_Generation = 73,
}

export const DocumentStatusToRemoveDIRP = [
    DocumentMainStatus.New,
    DocumentMainStatus.Draft
]
export const DocumentSubStatusToRemoveDIRP = [
    DocumentSubStatus.New,
    DocumentSubStatus.Draft,
    DocumentSubStatus.Aor_Draft,
    DocumentSubStatus.Woc_Draft,
    DocumentSubStatus.Woc_Dotp_Draft,
    DocumentSubStatus.D_Procurement_Draft,
    DocumentSubStatus.Sow_Draft,
    DocumentSubStatus.Vendor_Document_Draft,
    DocumentSubStatus.Rfs_Draft,
]

export const DocumentSubStatusToStrikeThroughDIRP = [
    DocumentSubStatus.Aor_Draft,
    DocumentSubStatus.Woc_Draft,
    DocumentSubStatus.Woc_Dotp_Draft,
    DocumentSubStatus.D_Procurement_Draft,
    DocumentSubStatus.Sow_Draft,
    DocumentSubStatus.Vendor_Document_Draft,
    DocumentSubStatus.Rfs_Draft,
]